import { ServiceFetch } from './service-fetch'

export default class PointExpireCustomerModel extends ServiceFetch {
    getPointExpireCustomerBy = (data) => this.authFetch({
        url: 'point-expire-customer/getPointExpireCustomerBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}